// Three states, never two: a Sistem Registrator that was never configured is not
// the same as one that is configured and switched off, and the register and the
// Registrar's own screen must not disagree about which is which. Switched off
// says by whom (CF-48): the Registrar Administrator reads the System
// Administrator's block by name, the System Administrator reads both.
import { useTranslate } from '@tolgee/react';
import { MudTag } from '@egov-moldova/mud-react';
import { BlockTags, CREDENTIAL_BLOCK_LABELS } from '../blocking/BlockTags';
import type { BlockViewer } from '../blocking/block-status';

export interface CredentialStatusTagProps {
  configured: boolean;
  active: boolean;
  blockedBySystemAdmin?: boolean;
  blockedByRegistrar?: boolean;
  viewer?: BlockViewer;
}

export function CredentialStatusTag({
  configured,
  active,
  blockedBySystemAdmin = false,
  blockedByRegistrar = false,
  viewer = 'REGISTRAR',
}: CredentialStatusTagProps): JSX.Element {
  const { t } = useTranslate();
  if (!configured) {
    // Accent, not muted — the same rule as CredentialTag, and the same wireframe line.
    return <MudTag variant="status" semantic="brand" label={t('credentials.status.unset')} />;
  }
  return (
    <BlockTags
      item={{ active, blockedBySystemAdmin, blockedByRegistrar }}
      viewer={viewer}
      labels={CREDENTIAL_BLOCK_LABELS}
    />
  );
}
